import { useCallback } from 'react'

import { useSelector } from 'react-redux'

import { makeSelectEndpoints } from '@webapp/core/stores/global'

const ABSOLUTE_URL_PATTERN = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i

export const formatStaticAsset = (url: string, prefix: string): string => {
  if (!url) return ''
  if (ABSOLUTE_URL_PATTERN.test(url)) return url

  const base = prefix.endsWith('/') ? prefix : `${prefix}/`
  const relativePath = url.replace(/^\//, '')
  const path = base.endsWith('/static/')
    ? relativePath.replace(/^static\//, '')
    : relativePath

  return `${base}${path}`
}

export const useFormatStaticAsset = () => {
  const endpoints = useSelector(makeSelectEndpoints())
  const staticEndpoint = endpoints?.static ?? '/'

  return useCallback(
    (url: string) => formatStaticAsset(url, staticEndpoint),
    [staticEndpoint]
  )
}
